import React, { Component } from 'react';
import serverClientUtil from '../../../utils/serverClientUtil';

class Logo extends Component {
  render() {
    return (
      <div className="logoAligment">
        <a href={serverClientUtil.getLPFullURL('home')}>
          <img
            loading="lazy"
            src={'https://assetspwa.liverpool.com.mx/assets/images/newHeader_icons/header_logos/tru.svg'}
            className="headerLogo"
            alt="Principal logo"
            title="Principal logo"
            height={serverClientUtil.getChannel() === 'wap' ? '32' : '40'}
            width="178px"
          />
        </a>
      </div>
    );
  }
}

export default Logo;
